<template>
  <div>
    <NavTop></NavTop>
    <div class="menu1_box_content">
      <div class="content_bell">
        <div class="content_cont">
          <h2 class="content_bell_title">
            <span class="content_bell_title_span">{{ title }}</span>
            <sup class="content_bell_title_sup">
              <span>走进东方</span>
              <span>/{{ title }}</span>
            </sup>
          </h2>
          <ul class="content_bell_list">
            <li v-for="(item,index) in partList" :key="index" @click="nav(item)">
              <img
                :src="item.coverUrl"
                alt>
              <ul class="content_bell_operate">
                <h5>
                  <span>{{ item.title }}</span>
                </h5>
                <span v-html="item.content"></span>
                <div>{{ extractDate(item.publishTime) }}</div>
              </ul>
            </li>
          </ul>
          <div style="display: flex;justify-content: center;margin-top: 10px;width: 100%; ">
            <el-pagination background layout="prev, pager, next" :page-size="pageSize" @current-change="changeVal"
                           :total="total"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavTop from '../../../components/comcomponents/NavTop.vue'
import home from '../../../api/home'

export default {
  components: {NavTop},
  data () {
    return {
      // 每页数量
      pageSize: 15,
      // 总条数
      total: 0,
      // 标题
      title: '',
      // 数据
      partList: [],
    }
  },
  created () {
    this.getList(this.$route.params.tabBarId, 1, this.pageSize)
    this.XunHuan(this.$route.params.tabBarId)
  },
  watch: {
    // 使用字符串路径监听
    '$route.params.tabBarId': function (newVal, oldVal) {
      this.getList(this.$route.params.tabBarId, 1, 15)
      this.XunHuan(newVal)
    }
  },
  mounted () {
  },
  methods: {
    //跳转
    nav (item) {
      this.$router.push('/common/section/detail' + '/' + this.$route.params.tabBarId + '/' + item.tabBarId + '/' + item.id
    )
    },
    // 获取列表
    async getList (tabBarId, pageNum, pageSize) {
      try {
        const res = await home.getWenZhang({tabBarId, pageNum, pageSize})
        this.partList = res.rows
        this.total = res.total
      } catch (e) {
        console.log(e)
      }
    },
    // 截取日期
    extractDate (dateTimeStr) {
      // 使用空格分割日期和时间
      const parts = dateTimeStr.split(' ')
      // 返回日期部分
      return parts[0]
    },
    // 改变分页值
    changeVal (e) {
      console.log(e, 'valval')
      this.getList(this.$route.params.tabBarId, e, this.pageSize)
    },
    // 跳转
    navigateTo (path) {
      this.$router.push(path)
    },
    // 循环数据
    XunHuan (tabBarId) {
      if (tabBarId == 15) {
        this.title = '校园生活'
        return
      }
      if (tabBarId == 16) {
        this.title = '校园风采'
        return
      }
    }
  }

}
</script>
<style lang="less" scoped>
.menu1_box_content {
  min-height: calc(100% - 385px);

  .content_bell {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 29px;

    .content_cont {
      width: 1200px;
      min-width: 1200px;
      max-width: 1200px;

      .content_bell_title {
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        border-bottom: 1px solid #ccc;

        .content_bell_title_span {
          border-bottom: 2px solid #921e23;
          font-weight: 100;
          font-size: 24px;
          color: black;
        }

        .content_bell_title_sup {
          vertical-align: super;
          font-size: smaller;

          span {
            &:nth-child(1) {
              font-size: 13px;
              color: #666;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }

            &:nth-child(2) {
              font-size: 13px;
              font-weight: bold;
            }
          }
        }
      }

      .content_bell_list {
        display: flex;
        flex-direction: column;

        li {
          display: flex;
          padding: 38px 0;
          border-bottom: 1px solid #DDDDDD;

          img {
            width: 265px;
            min-width: 265px;
            max-width: 265px;
            height: 170px;
            margin-right: 15px;
          }

          .content_bell_operate {
            line-height: 25px;
            margin-left: 43px;
            position: relative;
            width: 100%;

            h5 {
              font-size: 100%;

              span {
                cursor: pointer;
                color: #666;
                font-size: 16px;
                margin: 0 !important;

                &:hover {
                  text-decoration: underline;
                }
              }
            }

            span {
              color: #666;
              font-size: 14px;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
              margin-top: 12px;
            }

            div {
              float: right;
              color: #666;
              font-size: 14px;
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
        }
      }
    }
  }
}

ul, ol, li {
  list-style: none;
}
</style>
<style lang="less">
.el-pager {
  .number:hover {
    background-color: #8D080E !important;
    color: #fff !important;
  }
}

.active {
  background-color: #8D080E !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/orient/style/index.vue